import VideosPage from '@modules/professional/page/VideosPage';
import { loader } from '@modules/professional/page/loaders/videos-page-loader.server';

export { loader };
export default VideosPage;
